import { useEffect, useRef, useState } from 'react';

import { isValidTime, maskTimeInput, normalizeTimeDraft } from './timeUtils';
import { BlockedTimes } from './types';

type UseTimeInputDraftParams = {
  value: string;
  onChange: (value: string) => void;
  blockedTimes?: BlockedTimes;
};

export const useTimeInputDraft = ({
  value,
  onChange,
  blockedTimes,
}: UseTimeInputDraftParams) => {
  const [draft, setDraft] = useState(value);
  const committedRef = useRef(value);

  useEffect(() => {
    committedRef.current = value;
    setDraft(value);
  }, [value]);

  const handleInputChange = (rawValue: string) =>
    setDraft(maskTimeInput(rawValue));

  const handleCommit = () => {
    const normalized = normalizeTimeDraft(draft);

    if (!isValidTime(normalized, blockedTimes)) {
      setDraft(committedRef.current);
      return;
    }

    setDraft(normalized);
    if (normalized === committedRef.current) return;

    committedRef.current = normalized;
    onChange(normalized);
  };

  const commitValue = (time: string) => {
    committedRef.current = time;
    setDraft(time);
    onChange(time);
  };

  return { draft, handleInputChange, handleCommit, commitValue };
};
